import script from "./ApplicantsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicantsTable.vue?vue&type=script&setup=true&lang=js"

import "./ApplicantsTable.vue?vue&type=style&index=0&id=3b7bfc30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b7bfc30"]])

export default __exports__